const search = {
    untitledResult: 'Untitled',
    noFacetOptions: 'No options in these results',
    noResultsHint: 'Try different keywords, or clear some filters.',
    types: {
      basic: 'Keyword',
      basicHint: 'Matches the words as typed',
      semantic: 'Semantic',
      semanticHint: 'Matches on meaning, not wording',
      exact: 'Exact',
      exactHint: 'Returns only literal matches',
    },
    sort: {
      relevance: 'Relevance',
      date: 'Date added',
      title: 'Title',
    },
    title: 'Search',
    searchDocuments: 'Search Documents',
    advancedSearch: 'Advanced Search',
    searchResults: 'Search Results',
    noResults: 'No results found',
    errorTitle: 'Search Error',
    searchIn: 'Search in',
    matchType: 'Match Type',
    exactMatch: 'Exact Match',
    fuzzyMatch: 'Fuzzy Match',
    suggestions: 'Suggestions',
    relatedDocuments: 'Related Documents',
    searchHistory: 'Search History',
    recentSearches: 'Recent searches',
    searchError: 'Search Error',
    searchFailed: 'Search failed',
    savedSearches: 'Saved Searches',
    // Search Page specific
    searchPlaceholder: 'Search for documents, reports, presentations...',
    filters: 'Filters',
    searchType: 'Search Type',
    searchTypes: {
      basic: 'Basic Search',
      semantic: 'Semantic Search',
      exact: 'Exact Match',
    },
    sortOptions: 'Sort Options',
    sortBy: 'Sort By',
    sortValues: {
      relevance: 'Relevance',
      title: 'Title',
    },
    order: 'Order',
    sortOrder: {
      desc: 'Descending',
      asc: 'Ascending',
    },
    active: 'Active',
    activeFilters: 'Active Filters',
    noDocumentsMatch: 'No documents match "{{query}}"',
    adjustTermsOrFilters: 'Try adjusting your search terms or filters',
    resultsSummary: '{{total}} results',
    resultsSummaryForQuery: '{{total}} results for "{{query}}"',
    searchTime: '({{time}}s)',
  };

export default search;
